import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ClientApi, RoleApi } from '../../../shared/sdk/services/custom/index';
import { ToastrService } from 'ngx-toastr';
import sweetalert2 from 'sweetalert2';
import { MatSort } from '@angular/material/sort';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import {
  debounceTime,
  map,
  distinctUntilChanged,
  filter,
} from 'rxjs/operators';
import { fromEvent } from 'rxjs';
import { CustomTitleService } from '../../../shared/services/custom-title.service';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss'],
})
export class UserListComponent implements OnInit {

  user;
  newUser: any;
  users;

  // table configuration
  public displayedColumns: string[] =
    ['name',  'email', 'role', 'actions'];
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatTable, { static: true }) table: MatTable<any>;
  @ViewChild(MatPaginator, { static: true }) public paginator: MatPaginator;

  public dataSource: MatTableDataSource<any>;

  @ViewChild('dialogRef', { static: true }) dialogRef: TemplateRef<any>;
  @ViewChild('nameSearchInput', { static: true }) nameSearchInput: ElementRef;
  @ViewChild('emailSearchInput', { static: true }) emailSearchInput: ElementRef;

  roles;
  isLoading: boolean;
  filter: any = {
    name:'',
    email:'',
    role:'all'
  };
  pageSize = 10;
  pageIndex = 0;
  pageSizeOptions = [10, 25, 50];
  elementsNumber: number;
  public constructor(
    private clientApi:  ClientApi,
    private roleApi: RoleApi,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private customTitleService: CustomTitleService,
  ) {
    this.dataSource = new MatTableDataSource([]);
  }
  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }
  ngOnInit() {
    // Establecer el título usando el CustomTitleService
    this.customTitleService.setTitleWithBreadcrumbs({
      title: 'Usuarios',
      breadcrumbs: [
        { text: 'Usuarios' }
      ],
    });
    
    this.user = JSON.parse(localStorage.getItem('user'));
    this.isLoading = true;
    this.roleApi.find().subscribe(
      (roles) => {
        this.roles = roles;
      });

      this.searchUsers();
      this.loadListenerTerm();
  }

  createUser() {
    this.newUser = {};
    this.dialog.open(this.dialogRef, {});
  }

  loadListenerTerm() {    
    this.configureDebounce(this.nameSearchInput?.nativeElement);
    this.configureDebounce(this.emailSearchInput?.nativeElement);
  }
  configureDebounce(nativeElement) {
    fromEvent(nativeElement, 'keyup').pipe(
      map((event: any) => {
        return event.target.value;
      }),
      filter(res => (res.length > 1 || res.length === 0)),
      debounceTime(1000),
      distinctUntilChanged(),
    ).subscribe(() => {      
       this.refresh();
    });
  }
    searchUsers(){
      this.isLoading = true;
      const filter:any = {
        where : {},
        limit: this.pageSize,
       skip: this.pageIndex * this.pageSize,
     };
      if(this.filter.name){
        filter.where['name'] = this.filter.name;
      }
      if(this.filter.email){
        filter.where['email'] = this.filter.email;
      } 
      if (this.filter.role !== 'all') {
        filter.include = {
          relation: 'roles',
          scope:{
            where:{ id: this.filter.role  },
          },
        };
      }      
      const customHeaders = (data:any) => {
        data.headers.set('filter', [JSON.stringify(filter)]);
        data.normalizedNames.set('filter', 'filter');
        return data;
      };
      const customHeadersCount = (data:any) => {
        data.headers.set('filter', [JSON.stringify({
          where: filter.where,
          include:  filter.include,
        })]);
        data.normalizedNames.set('filter', 'filter');
        return data;
      };
      this.clientApi.searchClientsWithFiltersCount(null,customHeadersCount).subscribe((count)=>{
        this.clientApi.searchClientsWithFilters(null,customHeaders).subscribe(
          (clients) => {
            console.log('clients',clients);

            this.users = clients;
            this.dataSource.data = clients;
            console.log('logcount',count);

            setTimeout(() => {
              this.elementsNumber = count;
            });
            this.isLoading = false;
          });
    })
    }
  saveUser() {
    if (this.newUser.id) { 
      this.isLoading = true;
      this.clientApi.patchClient(this.newUser.id, this.newUser).subscribe(
        (editedUser) => {
          this.dataSource.data.forEach((user, index) => {
            if (user.id === this.newUser.id) {
              this.dataSource.data[index] = editedUser;
            }
          });
          this.isLoading = false;
          this.toastr.success(
            `El usuario ${editedUser.name} se ha editado correctamente`,
            'Usuario editado',
            {
              positionClass: 'toast-bottom-right',
            });
        },
        () => {
          this.isLoading = false;
          this.toastr.error(
            'Ha ocurrido un error al editar el usuario',
            'Error',
            {
              positionClass: 'toast-bottom-right',
            });
        },
      );
    } else { // new user
      this.isLoading = true;
      this.clientApi.createClient(this.newUser).subscribe(
        (createdClient) => {
          this.users.push(createdClient);
          this.dataSource.data = this.users;
          this.isLoading = false;
          this.toastr.success(
            `El usuario ${createdClient.name} se ha creado correctamente`,
            'Usuario creado',
            {
              positionClass: 'toast-bottom-right',
            });
        },
        () => {
          this.toastr.error(
            'Ha ocurrido un error al crear el usuario',
            'Error',
            {
              positionClass: 'toast-bottom-right',
            });
        });
    }
  }
  editUser(user) {
    this.newUser = user;
    this.newUser.roleId = user.roles[0].id;
    this.dialog.open(this.dialogRef, {});
  }
  deleteUser(user) {
    sweetalert2.fire({
      title: 'Eliminar usuario',
      text: `¿Está seguro que desea eliminar al usuario ${user.name}?`,
      type: 'warning',
      showCancelButton: true,
      reverseButtons: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Si, Eliminar',
      customClass: {
        cancelButton: 'btn btn-ligth mx-1',
        confirmButton: 'btn btn-danger mx-1',
      },
      buttonsStyling: false,
    }).then((result) => {
      if (result.value) {
        this.isLoading = true;
        this.clientApi.deleteClient(user.id).subscribe(
          () => {
            this.users = this.users.filter(userArray => userArray.id !== user.id);
            this.dataSource.data = this.users;
            this.isLoading = false;
            this.toastr.success(
              `El usuario ${user.name} ha sido eliminado`,
              'Usuario eliminado',
              {
                positionClass: 'toast-bottom-right',
              });
          },
          () => {
            this.isLoading = false;
            this.toastr.error(
              'Ha ocurrido un error al eliminar el usuario',
              'Error',
              {
                positionClass: 'toast-bottom-right',
              });
          },
        );
      }
    });
  }
  canEditUser(userToEdit) {
    return userToEdit.roles[0].hierarchy > this.user.roles[0].hierarchy;
  }

  clearFilters(){
    this.filter  = {
      name:'',
      email:'',
      role:''
    };
    this.searchUsers();
  }

  onPaginateChange(event) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.searchUsers();
  }

  refresh(){
    this.pageSize = 10;
    this.pageIndex = 0;
    this.searchUsers();
  }
}
